import { MouseEvent, FunctionComponent, useState } from "react"

import Sidebar from "../features/sidebar/components/sidebar"
import HeaderSection from "../components/header-section"
import { DataColumn, Table } from "../components/table"

const TableSample: FunctionComponent = () => {
  const columns = [
    { name: "Name" },
    { name: "Age" },
    { name: "Email" },
    { name: "Phone" },
    { name: "Address" },
    { name: "City" },
    { name: "Country" },
    { name: "Company" },
  ]

  const filterConfig = {
    name: { values: ["John Doe", "Jane Doe", "Alice"] },
    age: { values: ["25", "23", "30"] },
    // Add more filter configurations as needed
  }

  const data: DataColumn[][] = [
    [
      { id: "1", name: "name", value: "John Doe" },
      { id: "2", name: "age", value: "25" },
      { id: "3", name: "email", value: "john.doe@example.org" },
      { id: "4", name: "phone", value: "555-1234" },
      { id: "5", name: "address", value: "123 Main St" },
      { id: "6", name: "city", value: "New York" },
      { id: "7", name: "country", value: "USA" },
      { id: "8", name: "company", value: "ABC Corp" },
    ],
    [
      { id: "4", name: "name", value: "Jane Doe" },
      { id: "5", name: "age", value: "23" },
      { id: "6", name: "email", value: "jane.doe@example.org" },
      { id: "7", name: "phone", value: "555-5678" },
      { id: "8", name: "address", value: "456 Elm St" },
      { id: "9", name: "city", value: "Los Angeles" },
      { id: "10", name: "country", value: "USA" },
      { id: "11", name: "company", value: "XYZ Corp" },
    ],
    [
      { id: "7", name: "name", value: "Alice" },
      { id: "8", name: "age", value: "30" },
      { id: "9", name: "email", value: "alice@example.org" },
      { id: "10", name: "phone", value: "555-9876" },
      { id: "11", name: "address", value: "789 Oak St" },
      { id: "12", name: "city", value: "Chicago" },
      { id: "13", name: "country", value: "USA" },
      { id: "14", name: "company", value: "123 Corp" },
    ],
    [
      { id: "15", name: "name", value: "Bob Smith" },
      { id: "16", name: "age", value: "28" },
      { id: "17", name: "email", value: "bob.smith@example.org" },
      { id: "18", name: "phone", value: "555-1112" },
      { id: "19", name: "address", value: "101 Maple St" },
      { id: "20", name: "city", value: "San Francisco" },
      { id: "21", name: "country", value: "USA" },
      { id: "22", name: "company", value: "DEF Corp" },
    ],
    [
      { id: "23", name: "name", value: "Charlie Brown" },
      { id: "24", name: "age", value: "29" },
      { id: "25", name: "email", value: "charlie.brown@example.org" },
      { id: "26", name: "phone", value: "555-2223" },
      { id: "27", name: "address", value: "202 Pine St" },
      { id: "28", name: "city", value: "Seattle" },
      { id: "29", name: "country", value: "USA" },
      { id: "30", name: "company", value: "GHI Corp" },
    ],
    [
      { id: "31", name: "name", value: "David Lee" },
      { id: "32", name: "age", value: "27" },
      { id: "33", name: "email", value: "david.lee@example.org" },
      { id: "34", name: "phone", value: "555-3334" },
      { id: "35", name: "address", value: "303 Cedar St" },
      { id: "36", name: "city", value: "Denver" },
      { id: "37", name: "country", value: "USA" },
      { id: "38", name: "company", value: "JKL Corp" },
    ],
    [
      { id: "39", name: "name", value: "Emily Chen" },
      { id: "40", name: "age", value: "26" },
      { id: "41", name: "email", value: "emily.chen@example.org" },
      { id: "42", name: "phone", value: "555-4445" },
      { id: "43", name: "address", value: "404 Cypress St" },
      { id: "44", name: "city", value: "Miami" },
      { id: "45", name: "country", value: "USA" },
      { id: "46", name: "company", value: "MNO Corp" },
    ],
    [
      { id: "47", name: "name", value: "Frank Davis" },
      { id: "48", name: "age", value: "31" },
      { id: "49", name: "email", value: "frank.davis@example.org" },
      { id: "50", name: "phone", value: "555-5556" },
      { id: "51", name: "address", value: "505 Fir St" },
      { id: "52", name: "city", value: "Boston" },
      { id: "53", name: "country", value: "USA" },
      { id: "54", name: "company", value: "PQR Corp" },
    ],
    [
      { id: "55", name: "name", value: "George Edwards" },
      { id: "56", name: "age", value: "32" },
      { id: "57", name: "email", value: "george.edwards@example.org" },
      { id: "58", name: "phone", value: "555-6667" },
      { id: "59", name: "address", value: "606 Gum St" },
      { id: "60", name: "city", value: "Dallas" },
      { id: "61", name: "country", value: "USA" },
      { id: "62", name: "company", value: "STU Corp" },
    ],
    [
      { id: "63", name: "name", value: "Helen Ford" },
      { id: "64", name: "age", value: "33" },
      { id: "65", name: "email", value: "helen.ford@example.org" },
      { id: "66", name: "phone", value: "555-7778" },
      { id: "67", name: "address", value: "707 Hickory St" },
      { id: "68", name: "city", value: "Washington D.C." },
      { id: "69", name: "country", value: "USA" },
      { id: "70", name: "company", value: "VWX Corp" },
    ],
    [
      { id: "71", name: "name", value: "Ivan Garcia" },
      { id: "72", name: "age", value: "34" },
      { id: "73", name: "email", value: "ivan.garcia@example.org" },
      { id: "74", name: "phone", value: "555-8889" },
      { id: "75", name: "address", value: "808 Ivy St" },
      { id: "76", name: "city", value: "Phoenix" },
      { id: "77", name: "country", value: "USA" },
      { id: "78", name: "company", value: "YZA Corp" },
    ],
    [
      { id: "79", name: "name", value: "Julia Hall" },
      { id: "80", name: "age", value: "35" },
      { id: "81", name: "email", value: "julia.hall@example.org" },
      { id: "82", name: "phone", value: "555-9990" },
      { id: "83", name: "address", value: "909 Juniper St" },
      { id: "84", name: "city", value: "Atlanta" },
      { id: "85", name: "country", value: "USA" },
      { id: "86", name: "company", value: "BCD Corp" },
    ],
    [
      { id: "87", name: "name", value: "Kevin Jackson" },
      { id: "88", name: "age", value: "36" },
      { id: "89", name: "email", value: "kevin.jackson@example.org" },
      { id: "90", name: "phone", value: "555-1011" },
      { id: "91", name: "address", value: "1011 Kite St" },
      { id: "92", name: "city", value: "Houston" },
      { id: "93", name: "country", value: "USA" },
      { id: "94", name: "company", value: "EFG Corp" },
    ],
    [
      { id: "95", name: "name", value: "Lisa Martin" },
      { id: "96", name: "age", value: "23" },
      { id: "97", name: "email", value: "lisa.martin@example.org" },
      { id: "98", name: "phone", value: "555-1213" },
      { id: "99", name: "address", value: "1113 Lark St" },
      { id: "100", name: "city", value: "San Diego" },
      { id: "101", name: "country", value: "USA" },
      { id: "102", name: "company", value: "HIJ Corp" },
    ],
  ]

  const [selectedData, setSelectedData] = useState<
    { check: boolean; usersDetails: DataColumn[] }[]
  >([])
  const [visibleData, setVisibleData] = useState<
    { check: boolean; usersDetails: DataColumn[] }[]
  >([])

  const rowClickAction = (e: MouseEvent<HTMLTableRowElement>) => {
    const rowId = e.currentTarget.id
    console.log("Clicked row with ID:", rowId)
  }

  const handleSelectionChange = (
    selectedRows: { check: boolean; usersDetails: DataColumn[] }[],
  ) => {
    setSelectedData(selectedRows)
  }

  const handleVisibleRowsChange = (
    visibleRows: { check: boolean; usersDetails: DataColumn[] }[],
  ) => {
    setVisibleData(visibleRows)
  }

  // Button actions
  const handleLogSelected = () => {
    console.log("Selected Rows:", selectedData)
  }

  const handleAlert = () => {
    alert("This is an alert!")
  }

  const buttons = [
    {
      action: handleLogSelected,
      label: "Log Selected Rows",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-6h2v4h-2v-4zm0-6h2v4h-2v-4z" />
        </svg>
      ),
    },
    { action: handleAlert, label: "Show Alert" },
  ]

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-row items-start justify-start font-text-md-regular">
      <Sidebar />
      <div className="w-full h-[100dvh] flex-1 flex flex-col">
        <HeaderSection />
        <Table
          columns={columns}
          data={data}
          buttons={buttons}
          rowClickAction={rowClickAction}
          onSelectionChange={handleSelectionChange}
          showCheckboxColumn={true}
          onVisibleRowsChange={handleVisibleRowsChange}
          filterConfig={filterConfig}
        />
        <div className="flex">
          <div className="flex-1 p-4">
            <h2 className="text-lg font-bold">
              Visible Rows ({visibleData.length}):
            </h2>
            <pre>{JSON.stringify(visibleData, null, 2)}</pre>
          </div>
          <div className="flex-1 p-4">
            <h2 className="text-lg font-bold">
              Selected Rows ({selectedData.length}):
            </h2>
            <pre>{JSON.stringify(selectedData, null, 2)}</pre>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TableSample
